import Vue from 'vue';
import Router from 'vue-router';
import BusinessApplication from '../pages/businessApplication';
import TripReimbursement from '../pages/tripReimbursement';
import BasicInformation from '../components/basicInformation';
import BasicInformation2 from '../components/basicInformation2';
import ApprovalOpinion from '../components/approvalOpinion';
import ApprovalOpinion2 from '../components/approvalOpinion2';
import HistoryApprove from '../components/historyApprove';
import Notfound from '../pages/404.vue';
import Nav from '../components/nav.vue';

Vue.use(Router);

const router= new Router({
    mode: 'history',
    routes: [{
            path: '*',
            name: 'notfound',
            component: Notfound
        },
        {
            path: '/applyfor',
            name: '1',
            component: BusinessApplication,
        },
        {
            path: '/reimburse',
            name: '2',
            component: TripReimbursement,
        },
        {
            path: '/basicInformation',
            name: 'basicInformation',
            component: BasicInformation
        },
        {
            path: '/basicInformation2',
            name: 'basicInformation2',
            component: BasicInformation2
        },
        {
            path: '/approvalOpinion',
            name: 'approvalOpinion',
            component: ApprovalOpinion
        },
        {
            path: '/approvalOpinion2',
            name: 'approvalOpinion2',
            component: ApprovalOpinion2
        },
        {
            path: '/historyApprove',
            name: 'historyApprove',
            component: HistoryApprove
        },
        {
            path: '/nav',
            name: 'nav',
            component: Nav
        }
    ]
});


router.beforeEach((to,from,next)=>{
    if (to.name==='1') {
        window.document.title='出差申请';
    }else if(to.name==="2"){
        window.document.title='差旅报销';
    }
    next();

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js